import axios from 'axios';
export default {
  async getAddressFromZipcode (zipcode) {
   if (zipcode.length != 7) {
       return false;
   }
    const zipcodeFirst = zipcode.slice(0, 3)
    const zipcodeLast = zipcode.slice(3, 7)
    try {
      const res = await axios.get('https://madefor.github.io/postal-code-api/api/v1/' + zipcodeFirst + '/' + zipcodeLast + '.json')
      if (res.data) {
        return {
          'prefcode': parseInt(res.data.data[0].prefcode),
          'address': res.data.data[0].ja.address1 + res.data.data[0].ja.address2 + res.data.data[0].ja.address3 + res.data.data[0].ja.address4
        }
      }
    } catch (error) {
      console.log(error)
    }
  },
}